import type {
    ComposableOptionsBase,
    Product,
    Sku
} from '~/types';
import {
    ProductAvailabilityStatus
} from '~/types';

export interface UseProductShopFormUtilsOptions extends Partial<ComposableOptionsBase> {
    product: Product;
    currentSku?: Ref<Nullable<Sku>>
}
export function useProductShopFormUtils(options: UseProductShopFormUtilsOptions) {
    const { product, currentSku } = options;
    const prodUid = product.uid;
    
    function getCacheUid(uid: string): string {
        return `${prodUid}:${uid}`;
    }

    const canShowProductRetailLinks = computed(
        () => product.retailers?.length &&
            currentSku?.value?.status &&
            [
                ProductAvailabilityStatus.Discontinued,
                ProductAvailabilityStatus.Backorder,
                ProductAvailabilityStatus.SoldOut
            ].includes(currentSku.value.status)
    );
    
    return {
        getCacheUid,
        canShowProductRetailLinks
    };
}
